import {createContext, use} from 'react'

type ProductImageLoading = 'eager' | 'lazy'

export const ProductMediaLoadingContext = createContext(false)

export function useProductMediaLoading(loading: ProductImageLoading = 'lazy'): ProductImageLoading {
  const shouldLoadMedia = use(ProductMediaLoadingContext)
  return loading === 'eager' || shouldLoadMedia ? 'eager' : 'lazy'
}
